import React, { useEffect, useMemo, useRef } from "react";
import {
  Box,
  Button,
  Center,
  Circle,
  Flex,
  FormLabel,
  Heading,
  Input,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import style from "./index.module.css";

import * as api from "../../../services/api";
import epilouge from "@fontsource/epilogue";
import roboto from "@fontsource/roboto";
import swAlert from "sweetalert2";
import { dateJSON, getMonthName } from "contants/contants";
import { generateNumberOfArray } from "helper/helper";

const Second = ({ formData, changeHandler, setPage, setFormData }) => {
  const navigate = useNavigate();
  const [date, setDate] = useState({
    month: "",
    date: "",
    year: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDate((state) => ({
      ...state,
      [name]: value,
    }));
  };


  useEffect(() => {
    if (date.date && date.month && date.year) {
      setFormData((state) => {
        return {
          ...state,
          companyEstablished: `${date.month}-${date.date}-${date.year}`,
          date: `${date.date}`,
          month: `${date.month}`,
          year: `${date.year}`,
        };
      });
    }
  }, [date]);

  return (
    <div>
      <Box>
        <Flex
          w="100vw"
          align="center"
          justify="center"
          flexDirection="column"
          py={10}
        >
          {/* Heading */}
          <Box>
            <Heading
              style={{ fontFamily: "Epilogue" }}
              fontSize={40}
              fontWeight={700}
            >
              Setup Company
            </Heading>
            <Text fontFamily={"Roboto"} fontSize={16} fontWeight={400}>
              Add company's basic information
            </Text>
          </Box>
          <Flex flexDir={"column"} w={[330, 330, 347, 347]}>
            {/* GST Number */}
            <Box
              border="1px solid #DCDCDC"
              py={2}
              px={2}
              borderRadius={12}
              mt={10}
              w={"100%"}
            >
              <Input
                placeholder="GST number"
                variant="unstyled"
                name="gstNumber"
                fontSize={16}
                fontFamily={roboto}
                value={formData.gstNumber}
                onChange={changeHandler}
                autoComplete="off"
                px={5}
              />
            </Box>
            <Box
              border="1px solid #DCDCDC"
              px={2}
              py={2}
              borderRadius={12}
              mt={4}
              w={"100%"}
            >
              <Input
                placeholder="Number of employees"
                variant="unstyled"
                name="numberOfEmployees"
                fontSize={16}
                type={"number"}
                fontFamily={roboto}
                value={formData.numberOfEmployees}
                onChange={changeHandler}
                autoComplete="off"
                px={5}
              />
            </Box>
            <lable className="fs-14 text-left my-1">
              (Company esbalishment date)
            </lable>
            <Flex gap={1}>
              <Select
                borderRadius={12}
                fontSize={16}
                onChange={handleChange}
                name="month"
              >
                <option hidden selected>
                  {formData.month ? formData.month : "Month"}
                </option>
                {getMonthName?.map((month) => (
                  <option value={month.short}>{month.name}</option>
                ))}
              </Select>
              <Select
                borderRadius={12}
                fontSize={16}
                onChange={handleChange}
                name="date"
              >
                <option hidden selected>
                  {formData.date ? formData.date : "Date"}
                </option>
                {date?.month &&
                  generateNumberOfArray(dateJSON[date.month]?.days)?.map(
                    (d) => (
                      <option value={d + 1 < 10 ? `0${d + 1}` : d + 1}>
                        {d + 1 < 10 ? `0${d + 1}` : d + 1}
                      </option>
                    )
                  )}
              </Select>
              <Select
                borderRadius={12}
                fontSize={16}
                onChange={handleChange}
                name="year"
              >
                <option hidden selected>
                  {formData.year ? formData.year : "Year"}
                </option>
                {generateNumberOfArray(
                  new Date()?.getFullYear() + 1 - 1920
                )?.map((y) => (
                  <option
                    value={
                      y + 1920 < new Date().getFullYear()
                        ? y + 1920
                        : new Date().getFullYear()
                    }
                  >
                    {y + 1920 < new Date().getFullYear()
                      ? y + 1920
                      : new Date().getFullYear()}
                  </option>
                ))}
              </Select>
            </Flex>

            {/* <Input
                type={"test"}
                placeholder={"Company Est. date"}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => (e.target.type = "text")}
                variant="unstyled"
                name="companyEstablished"
                fontSize={20}
                fontFamily={roboto}
                value={formData.companyEstablished}
                onChange={changeHandler}
                autoComplete="off"
              /> */}
            <Box
              border="1px solid #DCDCDC"
              px={2}
              py={2}
              borderRadius={12}
              mt={4}
              w={"100%"}
            >
              <Input
                placeholder="Website link"
                variant="unstyled"
                name="websiteLink"
                type={"url"}
                fontSize={16}
                required
                fontFamily={roboto}
                value={formData.websiteLink}
                onChange={changeHandler}
                autoComplete="off"
                px={5}
              />
            </Box>
            {/* <Box
            border="1px solid #DCDCDC"
            px={2}
            py={2}
            borderRadius={12}
            mt={4}
          >
            <Input
              placeholder="Address"
              variant="unstyled"
              name="companyAddress"
              fontSize={20}
              fontFamily={roboto}
              value={formData.companyAddress}
              onChange={changeHandler}
              autoComplete="off"
              px={5}
            />
          </Box> */}

            <Box w={"100%"}>
              <Textarea
                placeholder="About Company"
                variant="unstyled"
                name="bio"
                fontSize={16}
                fontFamily={roboto}
                value={formData.bio}
                onChange={changeHandler}
                autoComplete="off"
                border="1px solid #DCDCDC"
                px={7}
                py={2}
                height={"150px"}
                borderRadius={12}
                mt={4}
                resize={"none"}
              />
            </Box>
            <div className={style.btnGroup}>
              <button className={style.backBtn} onClick={() => setPage(0)}>
                Back
              </button>
              {!formData.gstNumber ||
              !formData.bio ||
              !formData.numberOfEmployees ||
              !formData.companyEstablished ||
              !formData.websiteLink ? (
                <button
                  disabled
                  style={{ cursor: "not-allowed" }}
                  className={style.nextBtn}
                >
                  Next
                </button>
              ) : (
                <button className={style.nextBtn} onClick={() => setPage(2)}>
                  Next
                </button>
              )}
            </div>
            <Flex
              display={"none"}
              bg={"#6C56FB"}
              align="center"
              justify="center"
              w={"100%"}
              gap={2}
              borderRadius={12}
              mt={4}
              _hover={{ bg: "#8E48FF" }}
              cursor={
                !formData.gstNumber ||
                !formData.bio ||
                !formData.numberOfEmployees ||
                !formData.companyEstablished ||
                !formData.websiteLink
                  ? "not-allowed"
                  : "pointer"
              }
              onClick={() => setPage(2)}
            >
              {/* Next Button */}
              <button
                style={{
                  cursor:
                    !formData.gstNumber ||
                    !formData.bio ||
                    !formData.numberOfEmployees ||
                    !formData.companyEstablished ||
                    !formData.websiteLink
                      ? "not-allowed"
                      : "pointer",
                  color: "#ffffff",
                  fontSize: "18px",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  letterSpacing: "0.04em",
                  padding: "0.5rem 3rem",
                }}
              >
                Next
              </button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </div>
  );
};
export default Second;
